module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (!_vm.experiences.length) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("No sales data yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.experiences), function(exp, index) {
    return _c('div', {
      key: exp.name,
      staticClass: "exp-row"
    }, [_c('div', {
      staticClass: "exp-rank",
      class: {
        first: index === 0
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', {
      staticClass: "exp-info"
    }, [_c('div', {
      staticClass: "exp-name"
    }, [_vm._v(_vm._s(exp.name))]), _vm._v(" "), _c('div', {
      staticClass: "exp-meta"
    }, [_vm._v(_vm._s(exp.bookings) + " bookings")])]), _vm._v(" "), _c('div', {
      staticClass: "exp-sales"
    }, [_vm._v(_vm._s(exp.sales))])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-head"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Top Experiences")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-11b17bb6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11b17bb6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/topExperiences.vue
// module id = 3007
// module chunks = 0